import TextArea from "Components/TextArea";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchRecommendation } from "../../Redux/Slices/failureAnalysisReqSlice";
import { RiDeleteBin5Line } from "react-icons/ri";
import "./styles.scss";
import TextEditor from "Components/RichTextArea";
import ImageModal from "Components/ImageModal";
import { uploadSingle } from "../../Redux/Slices/mainSlice";
import ImageEditorTest from "Components/ImageEditor";

const Recommendation = ({ id, onDataChange, setExist }) => {

  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState(null);
  const [bearingComponents, setBearingComponents] = useState([
    {
      id: 1,
      conclusion: null,
      conclusionImages: [
        { id: Date.now(), selectedImage: null, imgObservation: "" }
      ],
      recommendation: null,
      recommendationImages: [
        { id: Date.now() + 1, selectedImage: null, imgObservation: "" }
      ],
    }
  ]);

  const transformApiData = (data) => {
    const transformedData = data?.map(item => ({
      id: item?.recommendation_id,
      conclusion: item?.conclusion,
      conclusionImages: item?.conclusion_images?.length > 0
        ? item.conclusion_images.map(img => ({
          id: Date.now() + Math.random(),
          selectedImage: img?.image || null,
          imgObservation: img?.description || ""
        }))
        : [{ id: Date.now() + Math.random(), selectedImage: null, imgObservation: "" }],
      recommendation: item?.recommendation,
      recommendationImages: item?.recommendation_images?.length > 0
        ? item.recommendation_images.map(img => ({
          id: Date.now() + Math.random(),
          selectedImage: img?.image || null,
          imgObservation: img?.description || ""
        }))
        : [{ id: Date.now() + Math.random() + 1, selectedImage: null, imgObservation: "" }],
    }));

    console.log(transformedData, 'transformedData')
    setBearingComponents(transformedData);
    onDataChange(transformedData);
  };

  useEffect(() => {
    dispatch(
      fetchRecommendation({
        data: {
          remote_failure_details_id: id
        },
        callBack: (data) => {
          const actualData = Array.isArray(data) ? data : data?.data;
          console.log(actualData, 'preview');
          if (Array.isArray(actualData) && actualData.length > 0) {
            setExist(true);
            transformApiData(actualData);
          } else if (actualData && typeof actualData === 'object' && !Array.isArray(actualData) && Object.keys(actualData).length > 0) {
            setExist(true);
            transformApiData([actualData]);
          }
        }
      })
    )
  }, []);

  const addBearingComponent = () => {
    const newComponent = {
      id: Date.now(),
      conclusion: null,
      conclusionImages: [
        { id: Date.now() + Math.random(), selectedImage: null, imgObservation: "" }
      ],
      recommendation: null,
      recommendationImages: [
        { id: Date.now() + Math.random() + 1, selectedImage: null, imgObservation: "" }
      ],
    };
    setBearingComponents([...bearingComponents, newComponent]);
    onDataChange([...bearingComponents, newComponent])
  };

  const deleteBearingComponent = (id) => {
    const updatedComponents = bearingComponents.filter((comp) => comp.id !== id);
    setBearingComponents(updatedComponents);
    onDataChange(updatedComponents);
  };

  const updateBearingComponent = (id, field, value) => {
    const updatedComponents = bearingComponents.map((comp) =>
      comp.id === id ? { ...comp, [field]: value } : comp
    );
    setBearingComponents(updatedComponents);
    onDataChange(updatedComponents);
  };

  const handleFileChange = (componentId, containerId, file, type) => {
    setSelectedFile({ id: componentId, containerId, file, type });
  };

  const handleFileSave = (componentId, containerId, file, type) => {
    const formData = new FormData();
    formData.append("file", file);
    const uploadCB = (value) => {
      const updatedComponents = bearingComponents.map((comp) => {
        if (comp.id === componentId) {
          if (type === 'conclusion') {
            return {
              ...comp,
              conclusionImages: comp.conclusionImages.map((container) =>
                container.id === containerId
                  ? { ...container, selectedImage: value.data.url }
                  : container
              ),
            };
          } else {
            return {
              ...comp,
              recommendationImages: comp.recommendationImages.map((container) =>
                container.id === containerId
                  ? { ...container, selectedImage: value.data.url }
                  : container
              ),
            };
          }
        }
        return comp;
      });
      setBearingComponents(updatedComponents);
      onDataChange(updatedComponents);
    };

    dispatch(
      uploadSingle({
        data: formData,
        callBack: uploadCB,
      })
    );
  };

  const addConclusionImage = (componentId) => {
    const updatedComponents = bearingComponents.map((comp) =>
      comp.id === componentId
        ? {
          ...comp,
          conclusionImages: [
            ...comp.conclusionImages,
            { id: Date.now(), selectedImage: null, imgObservation: "" }
          ]
        }
        : comp
    );
    setBearingComponents(updatedComponents);
    onDataChange(updatedComponents);
  };

  const deleteConclusionImage = (componentId, containerId) => {
    const updatedComponents = bearingComponents.map((comp) => {
      if (comp.id === componentId) {
        const updatedContainers = comp.conclusionImages.filter(
          (container) => container.id !== containerId
        );
        return {
          ...comp,
          conclusionImages: updatedContainers.length > 0 ? updatedContainers : [
            { id: Date.now(), selectedImage: null, imgObservation: "" }
          ]
        };
      }
      return comp;
    });
    setBearingComponents(updatedComponents);
    onDataChange(updatedComponents);
  };

  const addRecommendationImage = (componentId) => {
    const updatedComponents = bearingComponents.map((comp) =>
      comp.id === componentId
        ? {
          ...comp,
          recommendationImages: [
            ...comp.recommendationImages,
            { id: Date.now(), selectedImage: null, imgObservation: "" }
          ]
        }
        : comp
    );
    setBearingComponents(updatedComponents);
    onDataChange(updatedComponents);
  };

  const deleteRecommendationImage = (componentId, containerId) => {
    const updatedComponents = bearingComponents.map((comp) => {
      if (comp.id === componentId) {
        const updatedContainers = comp.recommendationImages.filter(
          (container) => container.id !== containerId
        );
        return {
          ...comp,
          recommendationImages: updatedContainers.length > 0 ? updatedContainers : [
            { id: Date.now(), selectedImage: null, imgObservation: "" }
          ]
        };
      }
      return comp;
    });
    setBearingComponents(updatedComponents);
    onDataChange(updatedComponents);
  };

  return (
    <div className="bearing-details-container">
      <h2>Conclusions And Recommendations</h2>
      {bearingComponents.map((component) => (
        <div key={component.id} className="bearing-component-container-asset">
          <div className="investigation-section">
            <div className="header-section-asset">
              <label className="investigationLabel">Conclusion</label>
              {bearingComponents.length > 1 && (
                <div
                  onClick={() => deleteBearingComponent(component.id)}
                  className="deleteIcon"
                >
                  <RiDeleteBin5Line size={20} color="red" />
                </div>
              )}
            </div>
          </div>
          <TextEditor
            placeholder="Enter Conclusion Here"
            value={component.conclusion}
            onChange={(e) =>
              updateBearingComponent(component.id, 'conclusion', e.target.value)
            }
          />
          {component.conclusionImages.map((container) => (
            <div key={container.id} className="imgAndObservationContainerAssets" style={{ marginTop: '20px' }}>
              <div>
                <label className="investigationLabel">Upload Image</label>
                <input
                  type="file"
                  accept="image/*"
                  id={`fileInput-conclusion-${component.id}-${container.id}`}
                  style={{ display: "none" }}
                  onChange={(event) =>
                    handleFileChange(component.id, container.id, event.target.files[0], 'conclusion')
                  }
                />
                <button
                  type="button"
                  className="uploadButton"
                  onClick={() =>
                    document.getElementById(`fileInput-conclusion-${component.id}-${container.id}`).click()
                  }
                >
                  Upload
                </button>
                {container.selectedImage && (
                  <div style={{ marginTop: "20px" }}>
                    <ImageModal
                      src={container.selectedImage}
                      alt="ConclusionImage"
                      onDelete={() => {
                        const input = document.getElementById(`fileInput-conclusion-${component.id}-${container.id}`);
                        if (input) input.value = "";
                        const updatedComponents = bearingComponents.map((comp) =>
                          comp.id === component.id
                            ? {
                              ...comp,
                              conclusionImages: comp.conclusionImages.map(c =>
                                c.id === container.id ? { ...c, selectedImage: null } : c
                              )
                            }
                            : comp
                        );
                        setBearingComponents(updatedComponents);
                        onDataChange(updatedComponents);
                      }}
                    />
                  </div>
                )}
              </div>
              <TextEditor
                placeholder="Enter Image Observation Here (Max 100 characters)"
                value={container.imgObservation}
                onChange={(e) => {
                  const updatedComponents = bearingComponents.map((comp) =>
                    comp.id === component.id
                      ? {
                        ...comp,
                        conclusionImages: comp.conclusionImages.map(c =>
                          c.id === container.id ? { ...c, imgObservation: e.target.value } : c
                        )
                      }
                      : comp
                  );
                  setBearingComponents(updatedComponents);
                  onDataChange(updatedComponents);
                }}
              />
              {component.conclusionImages.length > 1 && (
                <div
                  onClick={() => deleteConclusionImage(component.id, container.id)}
                  className="deleteIcon"
                >
                  <RiDeleteBin5Line size={20} color="red" />
                </div>
              )}
            </div>
          ))}
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              type="button"
              className="add-button"
              onClick={() => addConclusionImage(component.id)}
            >
              Add Image
            </button>
          </div>
          <div className="investigation-section" style={{ marginTop: '20px', marginBottom: '10px' }}>
            <div className="header-section-asset">
              <label className="investigationLabel">Recommendation</label>
            </div>
          </div>
          <TextEditor
            placeholder="Enter Recommendation Here"
            value={component.recommendation}
            onChange={(e) =>
              updateBearingComponent(component.id, 'recommendation', e.target.value)
            }
          />
          {component.recommendationImages.map((container) => (
            <div key={container.id} className="imgAndObservationContainerAssets" style={{ marginTop: '20px' }}>
              <div>
                <label className="investigationLabel">Upload Image</label>
                <input
                  type="file"
                  accept="image/*"
                  id={`fileInput-recommendation-${component.id}-${container.id}`}
                  style={{ display: "none" }}
                  onChange={(event) =>
                    handleFileChange(component.id, container.id, event.target.files[0], 'recommendation')
                  }
                />
                <button
                  type="button"
                  className="uploadButton"
                  onClick={() =>
                    document.getElementById(`fileInput-recommendation-${component.id}-${container.id}`).click()
                  }
                >
                  Upload
                </button>
                {container.selectedImage && (
                  <div style={{ marginTop: "20px" }}>
                    <ImageModal
                      src={container.selectedImage}
                      alt="RecommendationImage"
                      onDelete={() => {
                        const input = document.getElementById(`fileInput-recommendation-${component.id}-${container.id}`);
                        if (input) input.value = "";
                        const updatedComponents = bearingComponents.map((comp) =>
                          comp.id === component.id
                            ? {
                              ...comp,
                              recommendationImages: comp.recommendationImages.map(c =>
                                c.id === container.id ? { ...c, selectedImage: null } : c
                              )
                            }
                            : comp
                        );
                        setBearingComponents(updatedComponents);
                        onDataChange(updatedComponents);
                      }}
                    />
                  </div>
                )}
              </div>
              <TextEditor
                placeholder="Enter Image Observation Here (Max 100 characters)"
                value={container.imgObservation}
                onChange={(e) => {
                  const updatedComponents = bearingComponents.map((comp) =>
                    comp.id === component.id
                      ? {
                        ...comp,
                        recommendationImages: comp.recommendationImages.map(c =>
                          c.id === container.id ? { ...c, imgObservation: e.target.value } : c
                        )
                      }
                      : comp
                  );
                  setBearingComponents(updatedComponents);
                  onDataChange(updatedComponents);
                }}
              />
              {component.recommendationImages.length > 1 && (
                <div
                  onClick={() => deleteRecommendationImage(component.id, container.id)}
                  className="deleteIcon"
                >
                  <RiDeleteBin5Line size={20} color="red" />
                </div>
              )}
            </div>
          ))}
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              type="button"
              className="add-button"
              onClick={() => addRecommendationImage(component.id)}
            >
              Add Image
            </button>
          </div>
        </div>
      ))}

      {selectedFile && (
        <div className="modalOverlay">
          <div className="modalContent">
            <ImageEditorTest
              file={selectedFile.file}
              onSave={(editedFile) => handleFileSave(selectedFile.id, selectedFile.containerId, editedFile, selectedFile.type)}
              onClose={() => setSelectedFile(null)}
            />
          </div>
        </div>
      )}
    </div>
  );

};

export default Recommendation;
